export default __webpack_public_path__ + "images/PN.2dc8e16.png";